import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "text-2xl font-bold text-gray-900 mb-6" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-sm font-medium text-blue-800 shrink-0" }
const _hoisted_10 = { class: "flex-1 min-w-0" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "text-xs text-gray-400 shrink-0 ml-2" }
const _hoisted_13 = { class: "flex items-center justify-between mt-0.5" }
const _hoisted_14 = { class: "text-sm text-gray-500 truncate" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_17 = {
  key: 1,
  class: "italic"
}
const _hoisted_18 = {
  key: 0,
  class: "ml-2 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-blue-600 rounded-full shrink-0"
}
const _hoisted_19 = {
  key: 1,
  class: "text-center text-gray-400 text-sm py-8"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "messages"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString($setup.t('messages.title')), 1 /* TEXT */),
      _createCommentVNode(" Search "),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.search) = $event)),
          type: "text",
          placeholder: $setup.t('messages.search_placeholder'),
          class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        }, null, 8 /* PROPS */, _hoisted_5), [
          [_vModelText, $setup.search]
        ])
      ]),
      _createCommentVNode(" Conversations list "),
      ($setup.filteredConversations.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredConversations, (conv) => {
              return (_openBlock(), _createElementBlock("a", {
                key: conv.id,
                href: `/conversations/${conv.id}`,
                class: "block bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:bg-gray-50 transition"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(conv.other_user?.name?.charAt(0)?.toUpperCase() || '?'), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['text-sm font-medium', conv.unread_count > 0 ? 'text-gray-900' : 'text-gray-700'])
                      }, _toDisplayString(conv.other_user?.name || $setup.t('messages.unknown_user')), 3 /* TEXT, CLASS */),
                      _createElementVNode("span", _hoisted_12, _toDisplayString($setup.formatDate(conv.last_message?.created_at || conv.updated_at)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, [
                        (conv.last_message)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                              (conv.last_message.user_id === $props.userId)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.t('messages.you')) + ": ", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createTextVNode(" " + _toDisplayString(conv.last_message.body), 1 /* TEXT */)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($setup.t('messages.no_messages')), 1 /* TEXT */))
                      ]),
                      (conv.unread_count > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(conv.unread_count), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($setup.t('messages.no_conversations')), 1 /* TEXT */))
    ])
  ]))
}